import styled from 'styled-components';

export const StyledTabContainer = styled.div`
  min-height: ${({ theme }) => theme.size.medium};
`;
